module.exports = __webpack_public_path__ + "img/newfooter.5ddb30e4.png";